import { format, parseISO } from "date-fns";

export const BAND_COLORS = {
  Excellent: "#10B981",
  Healthy: "#3B82F6",
  "Needs Attention": "#F59E0B",
  "High Risk": "#F97316",
  Critical: "#EF4444",
};

export const bandColor = (band) => BAND_COLORS[band] || "#64748B";

export const bandFor = (s) =>
  s >= 90 ? "Excellent" : s >= 75 ? "Healthy" : s >= 50 ? "Needs Attention" : s >= 25 ? "High Risk" : "Critical";

export const STATUS_STYLES = {
  Compliant: "bg-emerald-500/12 text-emerald-600 dark:text-emerald-400 border-emerald-500/25",
  Filed: "bg-emerald-500/12 text-emerald-600 dark:text-emerald-400 border-emerald-500/25",
  Posted: "bg-emerald-500/12 text-emerald-600 dark:text-emerald-400 border-emerald-500/25",
  "Auto-filed": "bg-teal-500/12 text-teal-600 dark:text-teal-300 border-teal-500/25",
  Flagged: "bg-red-500/12 text-red-600 dark:text-red-400 border-red-500/25",
  Active: "bg-emerald-500/12 text-emerald-600 dark:text-emerald-400 border-emerald-500/25",
  Upcoming: "bg-blue-500/12 text-blue-600 dark:text-blue-400 border-blue-500/25",
  Invited: "bg-blue-500/12 text-blue-600 dark:text-blue-400 border-blue-500/25",
  "Due Soon": "bg-amber-500/12 text-amber-600 dark:text-amber-400 border-amber-500/25",
  "Needs Review": "bg-amber-500/12 text-amber-600 dark:text-amber-400 border-amber-500/25",
  Overdue: "bg-orange-500/12 text-orange-600 dark:text-orange-400 border-orange-500/25",
  Critical: "bg-red-500/12 text-red-600 dark:text-red-400 border-red-500/25",
  Dissolved: "bg-red-500/10 text-red-600 dark:text-red-300 border-red-500/30",
  "Revival In Progress": "bg-violet-500/12 text-violet-600 dark:text-violet-300 border-violet-500/25",
  Inactive: "bg-slate-500/12 text-slate-600 dark:text-slate-300 border-slate-500/25",
  Event: "bg-slate-500/12 text-slate-600 dark:text-slate-300 border-slate-500/25",
  High: "bg-red-500/12 text-red-600 dark:text-red-400 border-red-500/25",
  Medium: "bg-amber-500/12 text-amber-600 dark:text-amber-400 border-amber-500/25",
  Low: "bg-emerald-500/12 text-emerald-600 dark:text-emerald-400 border-emerald-500/25",
  None: "bg-slate-500/10 text-slate-500 border-slate-500/20",
};

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return format(parseISO(d.slice(0, 10)), "MMM d, yyyy");
  } catch {
    return d;
  }
};

export const money = (n, cur = "CAD") =>
  n == null || n === "" ? "—" : `${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${cur || ""}`;

export const daysLabel = (n) => (n == null ? "" : n < 0 ? `${Math.abs(n)}d late` : n === 0 ? "today" : `in ${n}d`);

export const csv = (s) => (s || "").split(",").map((x) => x.trim()).filter(Boolean);
